<script>
    let imageMystargoods = "./images/footer-mystargoods.png"
    let imageGoodnews = "./images/footer-9oodnews.png";
    let imageFandomship = "./images/footer-fandomship.png";

    let companyaDatas = [
        {id: 1, subject: '마이스타굿즈', link: 'https://mystargoods.com', img: imageMystargoods },
        {id: 2, subject: '굿뉴스닷컴', link: 'https://www.9oodnews.com', img: imageGoodnews },
        {id: 3, subject: '팬덤십', link: 'https://fandomship.com/klist.php', img: imageFandomship},
    ]
</script>
<footer class="footer">
    <div class="companya">
        {#each companyaDatas as companyaData (companyaData.id)}
            <button class="companya__item" on:click={()=>window.open(companyaData.link)}><img src={companyaData.img} alt={companyaData.subject} /></button>
        {/each}
    </div>
    <div class="copyright">Copyrights(c) 2023. All Rights Reserved.</div>
</footer>

<style>
    .footer {
        border-top: 1px solid var(--color-border);
        margin-top: 50px;
        padding-bottom: 50px;
    }
    .companya {
        display: flex;
        padding: 0 10px;
    }
    .companya__item {
        flex: 1;
        text-align: center;
        padding: 30px 0;
    }
    .companya__item img {
        height: 30px;
    }
    .copyright {
        border-top: 1px solid var(--color-border);
        padding-top: 20px;
        text-align: center;
        font-size: 11px;
        color: #777;
    }

    @media all and (max-width:460px) {
        .companya__item {
            padding: 20px 0;
        }
        .companya__item img {
            height: 24px;
        }
    }
</style>